<template>
    <app-layout>
        <app-header slot="app-header"/>
        <div class="page">
            <error-icon/>
            <as-sub-title class="page-title">Something went wrong</as-sub-title>
            <p>There has been an issue communicating with our servers. Please try again in a few minutes.</p>
        </div>
        <app-footer slot="app-footer"/>
    </app-layout>
</template>

<script>
    import AppLayout from '../components/Layout/AppLayout.vue'
    import AppHeader from '../components/Layout/AppHeader.vue'
    import AppFooter from '../components/Layout/AppFooter.vue'
    import ErrorIcon from '../components/Icons/ErrorIcon.vue'
    import AsSubTitle from '@/components/Ui/AsSubTitle.vue'
    export default {
        name: "NotFound",
        components: {
            AppLayout,        
            AppHeader,
            AppFooter,
            ErrorIcon,
            AsSubTitle
        }
  ,
                AsSubTitle  }
</script>

<style lang="scss" scoped>
    @import "@/styles/core.scss";
    .page {
        flex: 1;
        width: 100%;
        max-width: 560px;
        padding: 30px;
        margin: 0px auto;
        font-family: $bodyFontFamily;
        text-align: $textAlignBody;
        .page-title { margin-bottom: 30px; }
    }
</style>